<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <div style="margin-bottom: 16px">
      <a-button type="primary" @click="handleAdd">添加素材</a-button>
    </div>

    <!-- 表格 -->
    <MyTable
      ref="table"
      :apiUrl="material_index"
      :columns="columns"
      :rowKey="'id'"
    >
      <span slot="url" slot-scope="text, record">
        <template v-if="record.type === 1">
          <a :href="text" target="_blank">{{ text }}</a>
        </template>
        <template v-else-if="record.type === 2">
          <img
            :src="text"
            style="width: 50px; height: 50px; object-fit: cover"
          />
        </template>
        <template v-else> - </template>
      </span>
      <span slot="type" slot-scope="text">
        {{ getTypeName(text) }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button type="primary" size="small" @click="handleEdit(record)"
          >编辑</a-button
        >
      </span>
    </MyTable>

    <!-- 模态框 -->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="800px"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="素材名称" prop="material_id">
          <a-select
            v-model="form.material_id"
            placeholder="请选择素材名称"
            @change="handleMaterialChange"
          >
            <a-select-option
              v-for="item in materialItemList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="分类" required>
          <a-cascader
            v-model="classificationValue"
            :options="categoryOptions"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择分类/素材"
            @change="handleCategoryChange"
            change-on-select
          />
        </a-form-model-item>

        <a-form-model-item label="素材类型" prop="is_goods">
          <a-radio-group v-model="form.is_goods" @change="fetchTags">
            <a-radio :value="0">企业素材</a-radio>
            <a-radio :value="1">商品素材</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="form.sort" :min="0" style="width: 100%" />
        </a-form-model-item>

        <a-form-model-item label="视频">
          <myUpload
            :authApi="material_upload"
            uploadType="video"
            clickType="common"
            :maxLength="10"
            :list="videoUrls"
            @result="handleVideoUpload"
            @remove="handleVideoRemove"
          />
          <div
            v-for="(video, index) in form.videos"
            :key="'v' + index"
            style="margin-top: 10px; display: flex; align-items: center"
          >
            <span style="width: 80px">视频 {{ index + 1 }} 标签: </span>
            <a-select
              v-model="video.tag_id"
              placeholder="请选择标签"
              style="flex: 1"
            >
              <a-select-option
                v-for="tag in videoTagList"
                :key="tag.id"
                :value="tag.id"
                >{{ tag.name }}</a-select-option
              >
            </a-select>
          </div>
          <div class="tip">支持上传多个视频</div>
        </a-form-model-item>

        <a-form-model-item label="图片">
          <myUpload
            :authApi="material_upload"
            uploadType="img"
            clickType="common"
            :maxLength="10"
            :list="imageUrls"
            @result="handleImageUpload"
            @remove="handleImageRemove"
          />
          <div
            v-for="(image, index) in form.images"
            :key="'i' + index"
            style="margin-top: 10px; display: flex; align-items: center"
          >
            <span style="width: 80px">图片 {{ index + 1 }} 标签: </span>
            <a-select
              v-model="image.tag_id"
              placeholder="请选择标签"
              style="flex: 1"
            >
              <a-select-option
                v-for="tag in imageTagList"
                :key="tag.id"
                :value="tag.id"
                >{{ tag.name }}</a-select-option
              >
            </a-select>
          </div>
          <div class="tip">支持上传多张图片</div>
        </a-form-model-item>

        <a-form-model-item label="文案">
          <div
            v-for="(text, index) in form.texts"
            :key="index"
            style="margin-bottom: 10px; display: flex"
          >
            <a-textarea
              v-model="form.texts[index]"
              placeholder="请输入文案内容"
              :rows="2"
            />
            <a-button
              type="link"
              icon="delete"
              @click="removeText(index)"
              v-if="form.texts.length > 1"
            ></a-button>
          </div>
          <a-button type="dashed" block icon="plus" @click="addText"
            >添加文案</a-button
          >
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import myUpload from "@/components/myUpload.vue";
import {
  material_index,
  material_add,
  material_edit,
  material_category_index,
  material_tag_index,
  material_upload,
  material_item_index,
} from "@/api/material";

export default {
  name: "MaterialList",
  components: {
    MyTable,
    myUpload,
  },
  data() {
    return {
      material_index,
      material_upload,
      visible: false,
      confirmLoading: false,
      modalTitle: "添加素材",
      form: {
        id: undefined,
        group_id: undefined,
        material_name: "",
        material_id: undefined,
        category_id: undefined,
        brand_id: undefined,
        is_goods: 1,
        sort: 0,
        videos: [],
        images: [],
        texts: [""],
      },
      videoUrls: [],
      imageUrls: [],
      categoryOptions: [],
      videoTagList: [],
      imageTagList: [],
      materialItemList: [],
      classificationValue: [],
      rules: {
        material_id: [
          { required: true, message: "请选择素材名称", trigger: "change" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      columns: [
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 100,
          fixed: "left",
        },
        { title: "ID", dataIndex: "id", width: 80 },
        { title: "素材名称", dataIndex: "material_name" },
        { title: "组ID", dataIndex: "group_id" },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        { title: "标签", dataIndex: "tag_name" },
        { title: "文案内容", dataIndex: "content", ellipsis: true },
        { title: "排序", dataIndex: "sort" },
        { title: "更新时间", dataIndex: "update_at" },
      ],
    };
  },
  mounted() {
    this.fetchCategories();
    this.fetchTags();
    this.fetchMaterialItems();
  },
  methods: {
    fetchMaterialItems() {
      material_item_index({ page: 1, limit: 1000 }).then((res) => {
        this.materialItemList = res.list || res.result?.list || [];
      });
    },
    handleMaterialChange(val) {
      const selected = this.materialItemList.find((item) => item.id === val);
      if (selected) {
        this.form.material_name = selected.name;
        this.form.category_id = selected.category_id;
        this.form.brand_id = selected.brand_id;
      }
    },
    fetchCategories() {
      material_category_index({ page: 1, limit: 1000 }).then((res) => {
        this.categoryOptions = res.map((cat) => ({
          id: cat.id,
          name: cat.name,
          children: cat.children
            ? cat.children.map((sub) => ({
                id: sub.id,
                name: sub.name,
                children: sub.children
                  ? sub.children.map((mat) => ({
                      id: mat.id,
                      name: mat.name,
                      brand_id: mat.brand_id,
                      isLeaf: true,
                    }))
                  : [],
              }))
            : [],
        }));
      });
    },
    fetchTags() {
      material_tag_index({ page: 1, limit: 1000, type: 1, is_goods: this.form.is_goods }).then((res) => {
        this.videoTagList = res;
      });
      material_tag_index({ page: 1, limit: 1000, type: 2, is_goods: this.form.is_goods }).then((res) => {
        this.imageTagList = res;
      });
    },
    getTypeName(type) {
      const map = {
        1: "视频",
        2: "图片",
        3: "文案",
      };
      return map[type] || type;
    },
    handleAdd() {
      this.modalTitle = "添加素材";
      this.classificationValue = [];
      this.form = {
        id: undefined,
        group_id: undefined,
        material_name: "",
        material_id: undefined,
        category_id: undefined,
        brand_id: undefined,
        is_goods: 1,
        sort: 0,
        videos: [],
        images: [],
        texts: [""],
      };
      this.fetchTags();
      this.videoUrls = [];
      this.imageUrls = [];
      this.visible = true;
    },
    findPathByName(options, name) {
      for (const option of options) {
        if (option.children) {
          const path = this.findPathByName(option.children, name);
          if (path) {
            return [option.id, ...path];
          }
        } else if (option.name === name) {
          return [option.id];
        }
      }
      return null;
    },
    findPathById(options, id) {
      for (const option of options) {
        if (option.id === id) return [option.id];
        if (option.children) {
          const path = this.findPathById(option.children, id);
          if (path) {
            return [option.id, ...path];
          }
        }
      }
      return null;
    },
    async handleEdit(row) {
      this.modalTitle = "编辑素材";
      this.visible = true;

      this.videoUrls = [];
      this.imageUrls = [];
      this.form = {
        id: row.id,
        group_id: row.group_id,
        material_name: row.material_name,
        material_id: undefined,
        category_id: undefined,
        brand_id: undefined,
        is_goods: row.is_goods !== undefined ? row.is_goods : 1,
        sort: row.sort,
        videos: [],
        images: [],
        texts: [],
      };
      this.fetchTags();

      const path = this.findPathByName(this.categoryOptions, row.material_name);
      if (path) {
        this.classificationValue = path;
        if (path.length === 3) {
          this.form.category_id = path[1];
          this.form.material_id = path[2];
          const cat = this.categoryOptions.find((c) => c.id === path[0]);
          const sub = cat.children.find((s) => s.id === path[1]);
          const mat = sub.children.find((m) => m.id === path[2]);
          if (mat) this.form.brand_id = mat.brand_id;
        }
      } else {
        this.classificationValue = [];
      }

      try {
        const res = await material_index({
          page: 1,
          limit: 100,
          group_id: row.group_id,
        });
        const list = res.list || res.result || res || [];
        const groupItems = list.filter((item) => item.group_id == row.group_id);

        this.form.texts = [];
        groupItems.forEach((item) => {
          if (item.type === 1) {
            this.form.videos.push({
              url: item.url,
              duration: item.duration,
              file_size: item.file_size,
              tag_id: item.tag_id,
            });
            this.videoUrls.push(item.url);
          } else if (item.type === 2) {
            this.form.images.push({
              url: item.url,
              file_size: item.file_size,
              tag_id: item.tag_id,
            });
            this.imageUrls.push(item.url);
          } else if (item.type === 3 || item.content) {
            if (item.content && !item.url) {
              this.form.texts.push(item.content);
            }
          }
        });
        if (this.form.texts.length === 0) this.form.texts.push("");
      } catch (e) {
        console.error("Failed to fetch group details", e);
        if (row.type === 1) {
          this.form.videos.push({
            url: row.url,
            duration: row.duration,
            file_size: row.file_size,
            tag_id: row.tag_id,
          });
          this.videoUrls.push(row.url);
        } else if (row.type === 2) {
          this.form.images.push({
            url: row.url,
            file_size: row.file_size,
            tag_id: row.tag_id,
          });
          this.imageUrls.push(row.url);
        }
        if (row.content) {
          this.form.texts.push(row.content);
        } else {
          this.form.texts.push("");
        }
      }
    },
    handleCategoryChange(value, selectedOptions) {
      if (value.length === 3) {
        this.form.category_id = value[1];
        this.form.material_id = value[2];
        const materialOption = selectedOptions[2];
        this.form.brand_id = materialOption.brand_id;
      } else {
        this.form.category_id = undefined;
        this.form.material_id = undefined;
        this.form.brand_id = undefined;
      }
    },
    handleVideoUpload(result) {
      this.form.videos.push({
        url: result.url,
        duration: result.duration || 0,
        file_size: result.size || 0,
        tag_id: undefined,
      });
      this.videoUrls.push(result.url);
    },
    handleVideoRemove(info) {
      this.form.videos.splice(info.index, 1);
      this.videoUrls.splice(info.index, 1);
    },
    handleImageUpload(result) {
      this.form.images.push({
        url: result.url,
        file_size: result.size || 0,
        tag_id: undefined,
      });
      this.imageUrls.push(result.url);
    },
    handleImageRemove(info) {
      this.form.images.splice(info.index, 1);
      this.imageUrls.splice(info.index, 1);
    },
    addText() {
      this.form.texts.push("");
    },
    removeText(index) {
      this.form.texts.splice(index, 1);
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.material_id) {
            this.$message.warning("请选择完整的分类/素材");
            return;
          }
          const texts = this.form.texts.filter((t) => t.trim() !== "");

          if (
            this.form.videos.length === 0 &&
            this.form.images.length === 0 &&
            texts.length === 0
          ) {
            this.$message.warning("请至少上传一个视频、图片或填写文案");
            return;
          }

          this.confirmLoading = true;
          const params = {
            ...this.form,
            texts: texts,
          };
          const api = this.form.group_id ? material_edit : material_add;
          api(params)
            .then(() => {
              this.$message.success(
                this.form.group_id ? "修改成功" : "添加成功"
              );
              this.visible = false;
              this.$refs.table.getList();
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
</style>
